<template>
<b-card header="Perfis deste usuário">
      <b-table
        striped
        hover
        :items="listaPermissoes"
        :fields="[
          { key: 'actions', label: '' },
          { key: 'ug.ug', label: 'UG' },
          { key: 'perfil', label: 'Perfil' }
        ]">

        <template #cell(perfil)="data">
          <b-badge 
            v-for="(perfil, index) in data.item.perfis" :key="index"
            variant="secondary"
            class="mx-1 my-1"
            pill
            >
              {{perfil.perfil}}<b-button pill size="sm" @click="alertaPerfilRemove(perfil.idUsuarioPerfil, perfil.perfil)"><font-awesome-icon icon="xmark" /></b-button>
          </b-badge>
        </template>
        <template #cell(actions) = "data2"> 
          <b-button size="sm" variant="light" @click="alertaPermissaolRemove(data2.item.ug.idUnidadeGestora, data2.item.ug.ug )">
            <font-awesome-icon icon="trash"/>
          </b-button>
        </template>
      </b-table>
    </b-card>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { UtilsTS } from '@/utilsts';
import { Component, Vue, Watch} from 'vue-property-decorator';
import { Usuario } from '@/types/administracao/usuarios/usuario';
import { PropType } from 'vue';

import usuarioService from '@/services/administracao/usuarioService';
import { store } from "@/store";
const CompProps = Vue.extend({
    name: 'AbaCarregarPermissoesUsuario',
    props:{
      usuario: {
                type: Object as PropType<Usuario>,
                required: false
              },
    }
})





//Interface para organização de ug dentro da lista
interface ugUsuarioPerfil {
  ug: string;
  idUnidadeGestora: number;
}
//Interface para organização de Perfil dentro da lista
interface infosUsuarioPerfil {
  perfil: string;
  idUsuarioPerfil: number
}



interface AgrupadoPorUG {
  ug: {
    ug: string | undefined;
    idUnidadeGestora: number; 
  };
    perfis:{
    perfil: string;
    idUsuarioPerfil: number;
  }[];
}



@Component
export default class AbaCarregarPermissoesUsuario extends mixins(UtilsTS, CompProps) {
//Lista feita para agrupar os perfis relacionados a s ugs
listaPermissoes: AgrupadoPorUG[] = []

//teste para atualizar a listaPermissoes


//Quando o componente for atualizado
created(){
this.buscarPermissoes()
//console.log(this.usuario)
}



@Watch('usuario.perfis', { deep: true })
  onPerfisChange() {
    //console.log("Componente atualizado!")
    this.buscarPermissoes()
  }
  

buscarPermissoes(){
    
    this.listaPermissoes = [];
    //Itera o objeto usuario.perfis passado na prop
    this.usuario.perfis?.forEach((item) =>{

      //verifica se a UG do item atualmente iterado já existe no array listaPermissoes e retorna o elemento encontrado
      const UGexistente = this.listaPermissoes.find((perm)=> perm.ug.idUnidadeGestora === item.idUnidadeGestora)
      //Em caso de UGexistente retornar o elemento
      if(UGexistente){
        //Verifica se os perfis passados da UGexistente não contém os perfis do item

        const perfilExistente = UGexistente.perfis.find((perfil) => perfil.idUsuarioPerfil === item.idUsuarioPerfil);
        if(!perfilExistente){
          //Em caso da verificação retornar True, adiciona os perfis a essa UG 
          UGexistente.perfis.push({
            perfil: item.perfil.Descricao,
            idUsuarioPerfil: item.idUsuarioPerfil
          });

        }
      }else{
        //Em caso de UGexistente não retornar o elemento adiciona o elemento a lista, juntamente com seus perfis
        this.listaPermissoes.push({
          ug: {
            ug: item.ug,
            idUnidadeGestora: item.idUnidadeGestora,
          },
          perfis: [
            {
              perfil: item.perfil.Descricao,
              idUsuarioPerfil: item.idUsuarioPerfil
            }    
          ]
        })
      }
    })
    //console.log('Permissões do usuario:')
    //console.log(this.listaPermissoes)
  };

  
 //Função para excluir um perfil específico da permissão
 async excluirPerfil(id: number){
  
   try{
    store.blockScreen = true
    const response = await usuarioService.removerPerfilPermissao(id)
    //console.log(response.data)
   
    //Envia um aviso para o componente pai para ele enviar para o avô atualizar as informações da prop usuario
    this.$emit('evento-mudanca');
    this.$toast.success('Perfil removido com sucesso!')
   

   }catch(e: any){
    console.error(e)
    this.$toast.error('Erro ao remover perfil')
   }finally{
    store.blockScreen = false
   }

   
   
  }

  //Função para excluir toda a permissão
  async excluirPermissao(idug: string ){
    //conversão do valor de usuario para uma String
    const idUsuarioConvertido = this.usuario.ID_USUARIO.toString()
    try{

    store.blockScreen = true
    const response = await usuarioService.removerPermissaoUsuario(idUsuarioConvertido, idug)
    
    //Envia um aviso para o componente pai para ele enviar para o avô atualizar as informações da prop usuario
    this.$emit('evento-mudanca');

    this.$toast.success('Permissão removida com sucesso!')
   

   }catch(e: any){

    console.error(e)
    this.$toast.error('Erro ao remover permissão.')
   
   }finally{
    store.blockScreen = false
    
    
   }
   
    
    
    
  }
  

  //Alerta de confirmarção para excluir o perfil da permissão
  alertaPerfilRemove(idUP: number, nomeP: string): any {
    this.$bvModal.msgBoxConfirm(`Deseja remover o perfil de ${this.capitalize(nomeP)} ?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Confirmar',
      title: 'Remover perfil da permissão',
    }).then(value => {
      if (value) this.excluirPerfil(idUP)
    }).catch(err => {
      console.error(`Erro ao operar o dialog de alerta de remoção de perfil`, err)
    })
  }

  //alerta de confirmação para excluir a permissão completa
  alertaPermissaolRemove(idUG: string, nomeUG: string): any {
    this.$bvModal.msgBoxConfirm(`Deseja remover todas as permissões da Unidade Gestora ${this.capitalize(nomeUG)} ?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Confirmar',
      title: 'Remover permissão',
    }).then(value => {
      if (value) this.excluirPermissao(idUG)
    }).catch(err => {
      console.error(`Erro ao operar o dialog de alerta de remoção de perfil`, err)
    })
  }
}

</script>